import { object, boolean } from '~utils/validation';

export default object({
  takeAuthorization: boolean().oneOf([true]),
});
